<template>
  <v-card v-if="tipe == 'pilihInstansi'" class="mx-auto rounded-lg mb-6" max-width="344" outlined>
    <v-list-item three-line class="ma-2">
      <v-list-item-avatar
        tile
        :size="$vuetify.breakpoint.mdAndUp ? 60 : 20"
        color="primary"
        :class="$vuetify.breakpoint.mdAndUp ? 'rounded-lg' : 'rounded-sm'"
        ><div :class="$vuetify.breakpoint.mdAndUp ? 'text-h5 white--text' : ' white--text'">
          I
        </div></v-list-item-avatar
      >

      <v-list-item-content>
        <div class="text-overline mb-0 grey--text">
          Instansi
        </div>
        <v-list-item-title
          :class="$vuetify.breakpoint.mdAndUp ? 'text-h5 mb-6' : 'font-weight-medium mb-6'"
          style="white-space: normal;"
        >
          {{ title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions class="ma-2"
      ><v-spacer></v-spacer>
      <v-btn outlined text class="primary--text" @click="item.is_sync ? $emit('pilih') : ''" :disabled="!item.is_sync">
        {{ item.is_sync ? "Pilih" : "Belum Aktif" }}
      </v-btn>
    </v-card-actions>
  </v-card>
  <v-card v-else flat outlined class="mx-auto" max-width="400">
    <v-img class="white--text align-end" height="200px" :src="cover"></v-img>

    <v-card-text class="text--primary">
      <div class="title font-weight-bold">{{ title }}</div>

      <div>{{ desc }}</div>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="orange" text>
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: "Title"
    },
    subtitle: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: 0
    },
    role: {
      type: String,
      default: "User"
    },
    cover: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: "mdi-school"
    },
    height: {
      type: Number,
      default: 110
    },
    count: {
      type: Number,
      default: 0
    },
    desc: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String,
      default: null
    },
    iconDesc: {
      type: String,
      default: ""
    },
    progressBar: {
      type: String,
      default: "on"
    },
    progressValue: {
      type: Number,
      default: 10
    },
    showRole: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    },
    action: {
      type: Boolean,
      default: true
    },
    tipe: {
      type: String,
      default: "pilihInstansi"
    },
    is_sync: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Sinkronisasi Kelas",
          click: (i, o) => this.sinkronInstansi(o.id),
          check: (i, o) => o.is_sync == false
        },
        {
          title: "Ubah",
          click: (i, o) => this.$emit("edit", o)
        }
        // {
        //   title: "Hapus"
        // }
      ]
    };
  },
  methods: {
    sinkronInstansi(id) {
      return this.$store
        .dispatch("instansi/sync", { instansi_id: id })
        .then(res => {
          if (res) {
            this.$info("Sinkronisasi data Instansi berhasil");
            this.$emit("reload");
          }
        })
        .catch(() => {
          this.$error("Sinkronisasi data Instansi gagal");
        });
    }
  }
};
</script>

<style></style>
